import React from "react";

import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import "../css/Navbar.css";

function MyNavbar() {
  return (
    <Navbar id="navbar" expand="lg" className="navbar-dark scrolled">
      <Link to="/" aria-label="Life Center - Página inicial">
        <img className="logo" alt="Life Center logótipo" src={logo} />
      </Link>

      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
        <Nav>
          <Nav.Link as={Link} to="/sobre-nos" className="titulo">
            Sobre nós
          </Nav.Link>
          <div className="dropdown titulo-dropdown">
            <span className="titulo">Serviços</span>
            <div className="dropdown-content">
              <Nav.Link as={Link} className="titulo mx-0" to="/modalidades">
                Modalidades
              </Nav.Link>
              <Nav.Link
                as={Link}
                className="titulo mx-0"
                to="/triathlon-coaching"
              >
                Triathlon coaching
              </Nav.Link>
              <Nav.Link as={Link} className="titulo mx-0" to="/terapias">
                Terapias
              </Nav.Link>
              <Nav.Link as={Link} className="titulo mx-0" to="/estetica">
                Estética
              </Nav.Link>
              <Nav.Link
                as={Link}
                className="titulo mx-0"
                to="/clientes-empresariais"
              >
                Clientes Empresariais
              </Nav.Link>
            </div>
          </div>
          <Nav.Link as={Link} to="/contactos" className="titulo">
            Contactos
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default MyNavbar;
